import api from "../../../../api/api";

interface Result {
  event: string;
  info: {
    secure_url: string;
  };
}

async function uploadResult(
  result: Result,
  isCreateAcct: boolean
): Promise<string | boolean> {
  if (result.event === "success") {
    if (!isCreateAcct) {
      const res = await api.put("/api/addDealerLogoURL", {
        logoURL: result.info.secure_url,
      });
      if (res.data) return true;
      return false;
    } else {
      return result.info.secure_url;
    }
  }
  return false;
}

const getSignature = async (params_to_sign: any) => {
  return await api.post(`/api/cloudinaryGetSign`, { sign: params_to_sign });
};

const generateSignature = async (
  callback: (signature: any) => void,
  params_to_sign: any
) => {
  try {
    const signature = await getSignature(params_to_sign);
    callback(signature.data);
  } catch (err) {
    console.log(err);
  }
};

export { generateSignature, uploadResult };
